/**
 * Canonical JSON —— 签名与 CID 计算前的唯一序列化口径。
 *
 * 规则（ARCH §8.3）：键按字典序递归排序、无空格、剔除 `signature` / `sig` 字段后全量参与。
 * 任何一处序列化不一致都会导致跨端验签失败，因此**只允许**从这里取序列化实现。
 */

const OMITTED_KEYS = new Set(['signature', 'sig']);

/** 递归按字典序规范化任意 JSON 值。 */
function sortValue(value: unknown): unknown {
  if (value === null || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(sortValue);
  const source = value as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  for (const key of Object.keys(source).sort()) {
    if (OMITTED_KEYS.has(key)) continue;
    const v = source[key];
    if (v === undefined) continue;
    out[key] = sortValue(v);
  }
  return out;
}

/** 序列化为 canonical JSON 字符串（无空格，键有序，剔除签名字段）。 */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(sortValue(value));
}

/**
 * 序列化为 canonical 字节（供签名 / sha256 使用）。
 * 与 `canonicalJson` 等价，只是直接产出 UTF-8 字节，避免二次编码开销。
 */
export function canonicalBytes(value: unknown): Uint8Array {
  return new TextEncoder().encode(canonicalJson(value));
}
